// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateResult = objectOf({
  templates: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
  is_archived: boolean,
});
